export default __webpack_public_path__ + "static/media/1.eec7b302.svg";